module.exports = __webpack_public_path__ + "img/Logo(3).811449fc.svg";